module.exports = __webpack_public_path__ + "static/use-case-4-content-1-a-86b69fb5d98f5b90f02cae60d970a077.png";